var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__list"},[(_vm.isLoading)?_vm._l((8),function(item){return _c('ReportCardPlaceholder',{key:item})}):_vm._l((_vm.reports),function(report){return _c('ReportCard',{key:report.id,attrs:{"report":report}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }